import { render, staticRenderFns } from "./RoleUserListComponent.vue?vue&type=template&id=788b216a&scoped=true"
import script from "./RoleUserListComponent.vue?vue&type=script&lang=js"
export * from "./RoleUserListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b216a",
  null
  
)

export default component.exports